<script setup>
import { useLoadingBar, useMessage } from 'naive-ui'

window.$message = useMessage()
window.$loadingBar = useLoadingBar()
</script>

<template />
